import browser from 'browser-detect'
import siteCommon from './site-common'

let site = {
    browser: browser(),

    init: function () {
        //add browser name
        $('body').addClass("browser_" + site.browser.name);

        //mobile stuff
        $('.ui-link').removeClass('ui-link');

        //disable img drag
        $('img').on('dragstart', function (event) {
            event.preventDefault();
        });

        // DEVICE BRANCHES
        if (site.browser.mobile) {
            $('body').addClass("device-mobile");

            // mobile should not recalc on resize (flicker)
            window.addEventListener('orientationchange', site.siteOrientationChange);

        } else {
            $('body').addClass("device-notmobile");

            // desktop continues to recalc on resize
            window.addEventListener('resize', site.resize);
        }

        site.resize();
    },

    resize() {
        site.recalcVariables();
    },

    recalcVariables() {
        // ========== VH LOGIC ==========

        if (site.browser.mobile) {
            const total = window.screen.height;
            const viewport = window.innerHeight;

            const uiHeight = total - viewport;
            document.documentElement.style.setProperty('--ui-browser-height', `${uiHeight}px`);

            const vh = total * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        } else {
            // DESKTOP:
            // Use innerHeight and keep recalculating on resize.
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);

            document.documentElement.style.setProperty('--ui-browser-height', `0px`);
        }

        // ========== LEFT OFFSET ==========
        let ol = (window.innerWidth - 1920) / 2;
        if (ol < 0) ol = 0;
        document.documentElement.style.setProperty('--offsetLeft', `${ol}px`);
        window.offsetLeft = ol;
    },

    siteOrientationChange() {
        site.recalcVariables();
    }
};

export default site
